import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ValidationMessageKeys } from 'src/Configuration/validation'
import { z } from 'zod'
import { ResetPasswordFormValues } from '../types'

interface ReturnType {
  resetPasswordFormSchema: z.ZodType<ResetPasswordFormValues>
}

/**
 * Hook to validate "reset password form" with zod
 */
export const useValidateResetPasswordForm = (): ReturnType => {
  const { t } = useCustomTranslation()

  const resetPasswordFormSchema = z.object({
    username: z.string().min(1, t(ValidationMessageKeys.required)),
  })

  return { resetPasswordFormSchema }
}
